<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter1thelonelyking">CHAPTER 1 - THE LONELY KING</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter2murderonthetable">CHAPTER 2 - MURDER ON THE TABLE</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter3weirdcaptain">CHAPTER 3 - WEIRD CAPTAIN</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter4perfectsolution">CHAPTER 4 - PERFECT SOLUTION</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter5truemurdermethod">CHAPTER 5 - TRUE MURDER METHOD</a>
</li>
<li class="table-of-content">
<span href="#/5_chapter6thepowerbehindit" title="Link target outside of Sample">CHAPTER 6 - THE POWER BEHIND IT</span>
</li>
<li class="table-of-content">
<span href="#/6_chapter7jadependant" title="Link target outside of Sample">CHAPTER 7 - JADE PENDANT</span>
</li>
<li class="table-of-content">
<span href="#/7_chapter8shiftstudent" title="Link target outside of Sample">CHAPTER 8 - SHIFT STUDENT</span>
</li>
<li class="table-of-content">
<span href="#/8_chapter9affectedmilkteashop" title="Link target outside of Sample">CHAPTER 9 - AFFECTED MILK TEA SHOP</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter10blacknightconspiracy" title="Link target outside of Sample">CHAPTER 10 - BLACK NIGHT CONSPIRACY</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter11chip" title="Link target outside of Sample">CHAPTER 11 - CHIP</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter12dream" title="Link target outside of Sample">CHAPTER 12 - DREAM</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter13jadependant" title="Link target outside of Sample">CHAPTER 13 - JADE PENDANT</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter14theoriginofjadependant" title="Link target outside of Sample">CHAPTER 14 - THE ORIGIN OF JADE PENDANT</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter15twopeoplediarrhoea" title="Link target outside of Sample">CHAPTER 15 - TWO PEOPLE DIARRHOEA?</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter16mandateofthepresident" title="Link target outside of Sample">CHAPTER 16 - MANDATE OF THE PRESIDENT</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter17unexpectedidentity" title="Link target outside of Sample">CHAPTER 17 - UNEXPECTED IDENTITY</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter18gobacktothemilkteashop" title="Link target outside of Sample">CHAPTER 18 - GO BACK TO THE MILK TEA SHOP</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter19zhaoyaqing" title="Link target outside of Sample">CHAPTER 19 - ZHAO YA QING</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter20tohitawallistoretreatinordertoadvance" title="Link target outside of Sample">CHAPTER 20 - TO HIT A WALL IS TO RETREAT IN ORDER TO ADVANCE</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter21expense" title="Link target outside of Sample">CHAPTER 21 - EXPENSE</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter22recollection" title="Link target outside of Sample">CHAPTER 22 - RECOLLECTION</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter23troublewithzhaoyating" title="Link target outside of Sample">CHAPTER 23 - TROUBLE WITH ZHAO YATING</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter24zhaogroupsdestruction" title="Link target outside of Sample">CHAPTER 24 - ZHAO GROUP'S DESTRUCTION</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter25yanruxuansmethods" title="Link target outside of Sample">CHAPTER 25 - YAN RU XUAN'S METHODS</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter26molu" title="Link target outside of Sample">CHAPTER 26 - MO LU</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter27crown" title="Link target outside of Sample">CHAPTER 27 - CROWN</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter28pastlife1" title="Link target outside of Sample">CHAPTER 28 - PAST LIFE(1)</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter29pastlife2" title="Link target outside of Sample">CHAPTER 29 - PAST LIFE(2)</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter30pastlife3" title="Link target outside of Sample">CHAPTER 30 - PAST LIFE(3)</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter31pastlife4" title="Link target outside of Sample">CHAPTER 31 - PAST LIFE(4)</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter32pastlife5" title="Link target outside of Sample">CHAPTER 32 - PAST LIFE(5)</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter33itturnedouttobeadream" title="Link target outside of Sample">CHAPTER 33 - IT TURNED OUT TO BE A DREAM</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter34confession" title="Link target outside of Sample">CHAPTER 34 - CONFESSION</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter35together" title="Link target outside of Sample">CHAPTER 35 - TOGETHER</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter36cues" title="Link target outside of Sample">CHAPTER 36 - CUES</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter37four" title="Link target outside of Sample">CHAPTER 37 - FOUR</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter38choosetohide" title="Link target outside of Sample">CHAPTER 38 - CHOOSE TO HIDE</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter39thenewsituationintheclass" title="Link target outside of Sample">CHAPTER 39 - THE NEW SITUATION IN THE CLASS</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter40classmate" title="Link target outside of Sample">CHAPTER 40 - CLASSMATE</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter41playground" title="Link target outside of Sample">CHAPTER 41 - PLAYGROUND</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter42ruse" title="Link target outside of Sample">CHAPTER 42 - RUSE</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter43censure" title="Link target outside of Sample">CHAPTER 43 - CENSURE</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter44scolding" title="Link target outside of Sample">CHAPTER 44 - SCOLDING</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter45disciple" title="Link target outside of Sample">CHAPTER 45 - DISCIPLE?</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter46carbuncle" title="Link target outside of Sample">CHAPTER 46 - CARBUNCLE</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter47gangannihilate" title="Link target outside of Sample">CHAPTER 47 - GANG ANNIHILATE</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter48findmaster" title="Link target outside of Sample">CHAPTER 48 - FIND MASTER</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter49departure" title="Link target outside of Sample">CHAPTER 49 - DEPARTURE</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter50decision" title="Link target outside of Sample">CHAPTER 50 - DECISION</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter51awakening" title="Link target outside of Sample">CHAPTER 51 - AWAKENING</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter52snowdrop" title="Link target outside of Sample">CHAPTER 52 - SNOWDROP</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter53rainwater" title="Link target outside of Sample">CHAPTER 53 - RAINWATER</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter54away" title="Link target outside of Sample">CHAPTER 54 - AWAY</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?10cf809e